import * as React from 'react'
import Company from 'src/components/company-page/company/company.conn'
import Header from 'src/components/Shared/header/header'
import * as ReactGA from 'react-ga'

interface IState {
  hidden: boolean
}
export default class CompanyPage extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      hidden: true,
    }
  }

  render() {
    // const { children } = this.props;
    window.scrollTo(0, 0)
    ReactGA.pageview(window.location.pathname + window.location.search)

    return (
      <div className="black">
        <Header static={true} />
        <Company location={this.props.match.params.id} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/CompanyPage.tsx